import { api } from "@/utils/client";
import { keyBy } from 'lodash-es';
import Vue from "vue";

export default {
    namespaced: true,
    state: {
        ids: [],
        list: {},
        meta: {},
        selected: undefined,
        showingDeleted: false
    },
    getters: {
        orderedList(state) {
            return state.ids.map(id => state.list[id]);
        },
        selected(state) {
            return state.list[state.selected];
        }
    },
    mutations: {
        setList(state, list) {
            state.ids = list.map(({id}) => id)
            state.list = keyBy(list, 'id');
        },
        addItem(state, {id, ...item}) {
            if (!state.ids.includes(id)) {
                state.ids = [id, ...state.ids];
            }
            Vue.set(state.list, id, {id, ...item})
        },
        updateItem(state, {id, ...item}) {
            Vue.set(state.list, id, {id, ...item})
        },
        removeItem(state, id) {
            state.ids = state.ids.filter((_id) => _id !== id);
            Vue.delete(state.list, id)
        },
        setMeta(state, meta) {
            state.meta = meta;
        },
        setSelected(state, selected) {
            state.selected = selected;
        },
        setShowingDeleted(state, showingDeleted) {
            state.showingDeleted = showingDeleted;
        },
    },
    actions: {
        async getList({commit, rootState}, params = {}) {
            const {data: {data, meta}} = await api.get(`teams/${rootState.teamId}/surveys`, {params: {
                    ...params,
                    // deleted: !!state.showingDeleted
                }})
            commit('setList', data);
            commit('setMeta', meta);
            return data;
        },
        async getById({commit, rootState}, {id, ...params}) {
            const {data: {data}} = await api.get(`teams/${rootState.teamId}/surveys/${id}`, {params})
            commit('addItem', data);
            if (data.pages) {
                commit('surveyPages/setList', data.pages, {root: true})
            }
            if (data.theme) {
                commit('surveyThemes/addItem', data.theme, {root: true})
            }
            return data;
        },
        async getBySlug({commit}, {slug, team, ...params}) {
            const {data: {data: {pages, ...survey}}} = await api.get(`surveys/${team}/${slug}`, {params})
            commit('addItem', survey);
            commit('surveyPages/setList', pages, {root: true});
            return survey;
        },
        async create({commit, rootState}, payload) {
            const {data: {data}} = await api.post(`teams/${rootState.teamId}/surveys`, payload)
            commit('addItem', data);
            return data;
        },
        async update({commit, rootState}, {id, ...payload}) {
            const {data: {data}} = await api.put(`teams/${rootState.teamId}/surveys/${id}`, payload)
            commit('updateItem', data);
            if (data.theme) {
                commit('surveyThemes/updateItem', data.theme, {root: true})
            }
            return data;
        },
        async publish({commit, rootState}, {id}) {
            const {data: {data}} = await api.put(`teams/${rootState.teamId}/surveys/${id}/publish`)
            commit('updateItem', data);
            return data;
        },
        async unpublish({commit, rootState}, {id}) {
            const {data: {data}} = await api.put(`teams/${rootState.teamId}/surveys/${id}/unpublish`)
            commit('updateItem', data);
            return data;
        },
        async delete({commit, rootState}, {id}) {
            const {data: {data}} = await api.delete(`teams/${rootState.teamId}/surveys/${id}`)
            commit('updateItem', data);
            return data;
        },
        async restore({commit, rootState}, {id}) {
            const {data: {data}} = await api.put(`teams/${rootState.teamId}/surveys/${id}/restore`)
            commit('updateItem', data);
            return data;
        },
        async forceDelete({commit, rootState}, {id}) {
            const {data: {data}} = await api.delete(`teams/${rootState.teamId}/surveys/${id}`, {data: {permanent: true}})
            commit('removeItem', id);
            return data;
        },
    }

}
